<app-grid-container class="order-confirmation">
  <app-grid-row>
    <app-grid-column class="white-container">
      <app-grid-row>
        <app-grid-column>
          <h1 class="order-confirmation__title">
            <app-icon
              [family]="'solid'"
              [name]="'circle-check'"
              [size]="'xl'"
              class="order-confirmation__icon"
            />
            {{ "ORDER_CONFIRMATION_PAGE_TITLE" | translate }}
          </h1>
          <p class="order-confirmation__subtitle">
            {{ "ORDER_CONFIRMATION_PAGE_SUBTITLE" | translate }}
          </p>
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column [md]="4">
          <app-registered-appliance-summary />
        </app-grid-column>

        <app-grid-column [md]="4">
          <app-protected-appliance-summary
        /></app-grid-column>

        <app-grid-column [md]="4">
          <app-register-another-appliance />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
